/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const AssetsPublishedIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Assets Published',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m19.237 26.8 9.084 5.063a.819.819 0 0 0 1.1-.366l6.485-16.146ZM16.083 27.763V35.2a.5.5 0 0 0 .824.381l5.32-4.525ZM7.662 24H4V4h28v7.8l1.96-.611H34V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h8.667Z"
    />
    <path d="M34.791 13.535 9.078 21.444a.409.409 0 0 0-.066.759l7.114 3.479Z" />
  </svg>`;
};
